import { Box, Button, Dialog, DialogActions, DialogContent, Typography } from "@material-ui/core";
import { GetAppOutlined } from "@material-ui/icons";
import myFeedback from "assets/img/feedback.svg";
import { LightThemeTable } from "components/LightThemeTable";
import Loader from "components/Loader";
import Constants from "helpers/constants";
import React, { Component } from "react";
import { connect, ConnectedProps } from "react-redux";
import { Link, Redirect, RouteComponentProps, withRouter } from "react-router-dom";
import { State } from "state";
import { createAnalyticsEvent } from "state/analytics";
import { clearAnnouncements, fetchMyProjectAnnouncements } from "state/announcements";
import { fetchLoggedUserChainsRole } from "state/chain_permission";
import { clearFiles, fetchAllFiles, fetchFilesByProjectId } from "state/files";
import { fetchMyFeedback } from "state/my_feedback";
import { clearProject, fetchProject } from "state/project";
import { clearStore, fetchStoresByProjectId } from "state/stores";
import { PAGEVIEW_EVENTS, trackPageView } from "state/userEvents";
import ProjectAnnouncementsCard from "../components/ProjectAnnouncementsCard";
import ProjectDetailsCard from "../components/ProjectDetailsCard";
import ProjectFilesCard from "../components/ProjectFilesCard";

import { getItem } from "../helpers/storage";
import { IMPERSONATIONUSER } from "../state/auth";

import DefaultChainLogo from "assets/img/ChainParentDefaultLogo.png";
import axios from "axios";
import { default as Config, default as config } from "config";
import { getHeaders } from "helpers/headers";
import html2canvas from "html2canvas";
import { File } from "interfaces/file";
import jsPDF from "jspdf";
import { PDFDocument } from "pdf-lib";
import QRCode from "qrcode";
import { fetchProjectComments } from "state/project_comments";
import { getCalculatedStatus } from "utils/helpers";
import { resolveStoreIdsForProject } from "utils/storeIds";
import QrCodeIcon from "../components/icons/qrcodeicon";
import { decryptProjectId } from "../helpers/encryptUrlId";
import { fetchZipForFilesDownload } from "../state/batch_download";
import QrOverlay from "./QROverlay";
import QrPdfTemplate from "./QRPdfGenerator";
const mainContainerStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: "column",
  minHeight: "100vh",
  backgroundColor: "#F5F5F5",
  padding: "20px",
  borderRadius: "16px",
};

const contentAreaStyle: React.CSSProperties = {
  flexGrow: 1,
  padding: "0px",
  display: "flex",
  flexDirection: "column",
  gap: "24px",
};

const isMobile = window.innerWidth <= 768;

const cardsContainerStyle: React.CSSProperties = {
  display: "flex",
  gap: "24px",
  flexWrap: "wrap",
  minHeight: "300px",
  height: isMobile ? "max-content" : "300px",
};

const tableHeaderStyle: React.CSSProperties = {
  display: "flex",
  flexDirection: isMobile ? "column" : "row",
  justifyContent: "space-between",
  alignItems: isMobile ? "flex-start" : "center",
  paddingLeft: "10px",
  background: "#F9FAFB",
  marginBottom: "-22px",
};

const tableLinkStyle: React.CSSProperties = {
  color: "#E5B611",
  fontSize: "12px",
  textDecoration: "none",
  marginRight: "16px",
  fontWeight: 600,
};

const tableLinkIconStyle: React.CSSProperties = {
  fontSize: "12px",
  verticalAlign: "middle",
  marginLeft: "4px",
};

interface ProjectOwnProps extends RouteComponentProps<{ id: string; roleId: any }> {}

type ProjectProps = ProjectOwnProps & PropsFromRedux;

interface ProjectState {
  redirect: boolean;
  initialMountComplete: boolean;
  sort: string;
  size: number;
  page: number;
  chainRole: any;
  showNoCommentsModal: boolean;
  loadingQr: boolean;
  qrStage?: "checking" | "generating" | "completed";
  qrDataUrl: string;
  qrFileName: string;
  qrFileUrl: string;
  qrFileLogo?: string;
  qrStoreName?: string;
  qrStoreNumber?: string;
  qrErrorMessage?: string;
  zipDownloadTriggered: boolean;
  qrProgress?: { current: number; total: number };
}

class Project extends Component<ProjectProps, ProjectState> {
  private PROJECT_PAGE_SIZE = 20;
  private PROJECT_DEFAULT_SORT = "store_number.asc";

  constructor(props: ProjectProps) {
    super(props);
    this.state = {
      redirect: false,
      initialMountComplete: false,
      sort: this.PROJECT_DEFAULT_SORT,
      size: this.PROJECT_PAGE_SIZE,
      page: 0,
      chainRole: [],
      showNoCommentsModal: false,
      loadingQr: false,
      qrStage: undefined,
      qrDataUrl: "",
      qrFileName: "",
      qrFileUrl: "",
      qrErrorMessage: undefined,
      zipDownloadTriggered: false,
      qrProgress: undefined,
    };
  }

  async componentDidMount() {
    const { id } = this.props.match.params;
    const projectId = decryptProjectId(id);
    await this.loadProjectData(String(projectId));
  }

  loadProjectData = async (projectId: string) => {
    this.setState({ initialMountComplete: false });

    const {
      fetchProject,
      fetchFilesByProjectId,
      fetchStoresByProjectId,
      fetchMyProjectAnnouncements,
      trackPageView,
      user,
      fetchAllFiles,
    } = this.props;

    try {
      // Run API calls and 3s timer in parallel
      await Promise.all([
        (async () => {
          await fetchProject(projectId);
          //await fetchFilesByProjectId(projectId);
          await fetchMyProjectAnnouncements(projectId);

          const storeIds = await resolveStoreIdsForProject({
            projectId,
            storesInContext: this.props.stores || [],
            fetchStoresByProjectId,
          });

          await fetchAllFiles(
            projectId,
            storeIds ? { storeIds, includeNullStore: true } : { includeNullStore: true }
          );

          trackPageView({
            event_type: PAGEVIEW_EVENTS.ANNOUNCEMENTS_PAGEVIEW,
            user_id: user?.id,
            store_id: null,
            project_id: null,
            timestamp: Date.now(),
          });
        })(),
        new Promise((resolve) => setTimeout(resolve, 3000)), // minimum 3s
      ]);

      this.setState({ initialMountComplete: true });
    } catch (error) {
      console.error("Error loading project data:", error);
      this.setState({ initialMountComplete: true });
    }
  };
  componentDidUpdate(prevProps: ProjectProps) {
    const { id: currentId, roleId: currentRoleId } = this.props.match.params;
    const { id: prevId, roleId: prevRoleId } = prevProps.match.params;

    // Project ID changed
    if (currentId !== prevId) {
      const decryptedProjectId = decryptProjectId(currentId);
      this.loadProjectData(String(decryptedProjectId));
      return;
    }

    const currentProject = this.props.project;
    const prevProject = prevProps.project;

    //  Project loaded / changed
    if (currentProject?.id && currentProject?.id !== prevProject?.id) {
      const chainId = currentProject.chain?.id;
      if (chainId && currentRoleId) {
        this.props.fetchLoggedUserChainsRole(chainId, currentRoleId);
      }
      return;
    }

    // Role ID changed (THIS FIXES YOUR ISSUE)
    if (currentRoleId !== prevRoleId && currentProject?.chain?.id) {
      this.props.fetchLoggedUserChainsRole(currentProject.chain.id, currentRoleId);
    }
  }
  handleClick = () => {
    this.setState({ redirect: true });
  };
  handleClickOnRow = (value: any) => {
    const { history } = this.props;
    const { id, roleId } = this.props.match.params;
    const projectId = decryptProjectId(id);

    history.push(`/projects-new/${projectId}/stores/${value.store_id}`);
  };
  handleClickOnFeedBack = (id: string, roleId: string) => {
    const { history } = this.props;
    const { chainPermission } = this.props;

    const permission = chainPermission as Constants | undefined;

    const isProjectAdmin =
      !!permission &&
      (permission === Constants.INTERNAL_PROJECT_ADMIN ||
        permission === Constants.EXTERNAL_PROJECT_ADMIN);

    if (isProjectAdmin) {
      history.push(`/projects-new/${id}/${roleId}/review-feedback`);
    } else {
      history.push(`/projects-new/${id}/${roleId}/my-feedback/${id}`);
    }
  };

  handleCloseModal = () => {
    this.setState({ showNoCommentsModal: false });
  };

  getDaysLeft = (targetDate: string): number => {
    if (!targetDate) return 0;

    const now = new Date();
    const target = new Date(targetDate);

    if (isNaN(target.getTime())) {
      return 0;
    }
    // Normalize both dates to UTC midnight
    const nowUTC = Date.UTC(now.getUTCFullYear(), now.getUTCMonth(), now.getUTCDate());
    const targetUTC = Date.UTC(target.getUTCFullYear(), target.getUTCMonth(), target.getUTCDate());

    let diffDays = Math.floor((targetUTC - nowUTC) / (1000 * 60 * 60 * 24));

    // Ensure past dates return 0 instead of negative values
    if (diffDays < 0) {
      diffDays = 0;
    }

    return diffDays;
  };

  downloadFile = (url: string) => {
    if (!url) return;
    const encodedUrl = encodeURI(url);
    window.open(encodedUrl, "_blank");
  };

  downloadAllFiles = () => {
    const { files } = this.props;
    if (!files || files.length === 0) return;
    files.forEach((f) => {
      if (f.blob_url) {
        this.downloadFile(f.blob_url);
      }
    });
  };

  downloadPSAFiles = () => {
    const { files } = this.props;
    if (!files || files.length === 0) {
      return;
    }

    const psaFiles = files.filter(
      (f) => f.name.toLowerCase().endsWith(".psa") || f.extension.toLowerCase().endsWith("psa")
    );

    psaFiles.forEach((f) => {
      if (f.blob_url) {
        this.downloadFile(f.blob_url);
      }
    });
  };
  downloadPDFFiles = () => {
    const { files } = this.props;
    if (!files || files.length === 0) {
      return;
    }

    const psaFiles = files.filter((f) => f.name.toLowerCase().endsWith(".pdf"));

    psaFiles.forEach((f) => {
      if (f.blob_url) {
        this.downloadFile(f.blob_url);
      }
    });
  };

  handleCloseQrOverlay = () => {
    this.setState({
      loadingQr: false,
      qrStage: undefined,
      qrErrorMessage: undefined,
      qrDataUrl: "",
      qrFileUrl: "",
      qrFileName: "",
    });
  };

  private waitForImages = async (container: HTMLElement) => {
    const images = Array.from(container.querySelectorAll("img"));

    await Promise.all(
      images.map((img) => {
        if (img.complete && img.naturalHeight !== 0) return Promise.resolve();

        return new Promise<void>((resolve) => {
          img.onload = () => resolve();
          img.onerror = () => resolve();
        });
      })
    );
  };
  private waitForElement = (id: string): Promise<HTMLElement> => {
    return new Promise((resolve) => {
      const el = document.getElementById(id);
      if (el) {
        resolve(el);
        return;
      }
      const observer = new MutationObserver(() => {
        const element = document.getElementById(id);
        if (element) {
          observer.disconnect();
          resolve(element);
        }
      });
      observer.observe(document.body, {
        childList: true,
        subtree: true,
      });
    });
  };

  private handleDownloadAllStoreQrPdfs = async () => {
    const { project, stores, fetchStoresByProjectId } = this.props;
    if (!project?.id) return;

    this.setState({
      loadingQr: true,
      qrStage: "checking",
      qrErrorMessage: undefined,
      qrProgress: undefined,
    });
    try {
      let projectStores = stores;
      if (!projectStores || projectStores.length === 0) {
        await fetchStoresByProjectId(project.id);
        projectStores = this.props.stores;
      }

      if (!projectStores || projectStores.length === 0) {
        this.setState({
          qrStage: "completed",
          qrErrorMessage: "No stores found for this project.",
        });
        return;
      }
      type StoreWithFile = {
        store: typeof projectStores[0];
        file: File;
        fileLogo: string;
      };
      const storesWithFiles: StoreWithFile[] = [];
      for (const store of projectStores) {
        const storeId = store.store_id;

        const response = await axios.get(
          `${Config.API_SERVICE_URL}/api/projects/${project.id}/stores/${storeId}/files`,
          getHeaders()
        );

        const storeFiles: File[] = Array.isArray(response.data) ? response.data : [];

        const downloadFiles = storeFiles.filter((f) => f.extension === "pdf" && f.blob_url);

        if (!downloadFiles.length) continue;

        // for (const file of downloadFiles) {
        //   const fileLogo = file.chain_parent_logo ? file.chain_parent_logo : DefaultChainLogo;
        //   await this.handleGenerateQrPdf(file, storeName, storeNumber, fileLogo);
        //   await new Promise((r) => setTimeout(r, 80));
        //   await this.addQrPageToPdf(pdf, isFirstPage);
        //   isFirstPage = false;
        // }

        const latestFile = this.getLatestFile(downloadFiles);

        if (!latestFile) continue;

        const logoUrl = await this.fetchChainLogoDataUrl();
        storesWithFiles.push({ store, file: latestFile, fileLogo: logoUrl });
      }
      if (storesWithFiles.length === 0) {
        this.setState({
          loadingQr: true,
          qrStage: "completed",
          qrErrorMessage: "No PDF files available to download for any store.",
        });
        return;
      }
      const total = storesWithFiles.length;
      const PAGES_PER_PDF = 1000;
      const totalChunks = Math.ceil(total / PAGES_PER_PDF);
      this.setState({ loadingQr: true, qrStage: "generating", qrProgress: { current: 0, total } });
      for (let chunkIndex = 0; chunkIndex < totalChunks; chunkIndex++) {
        const chunk = storesWithFiles.slice(
          chunkIndex * PAGES_PER_PDF,
          (chunkIndex + 1) * PAGES_PER_PDF
        );
        const mergedPdf = await PDFDocument.create();
        for (const { store, file, fileLogo } of chunk) {
          const storeNumber = store?.store_number || store?.retail_store_num || "";
          const storeName = store.store_name || "Store";
          await this.handleGenerateQrPdf(file, storeName, storeNumber, fileLogo);
          const el = document.getElementById("qr-pdf")!;
          const canvas = await html2canvas(el, { scale: 1.5, useCORS: true });
          const singlePdf = this.createPdf();
          singlePdf.addImage(canvas.toDataURL("image/jpeg", 0.85), "JPEG", 0, 0, 210, 297);
          const pageBytes = new Uint8Array(singlePdf.output("arraybuffer"));
          const pagePdf = await PDFDocument.load(pageBytes);
          const [copiedPage] = await mergedPdf.copyPages(pagePdf, [0]);
          mergedPdf.addPage(copiedPage);
          await new Promise<void>((resolve) =>
            this.setState(
              (prev) => ({ qrProgress: { current: (prev.qrProgress?.current ?? 0) + 1, total } }),
              resolve
            )
          );
        }
        const mergedBytes = await mergedPdf.save();
        const blob = new Blob([mergedBytes.buffer as ArrayBuffer], { type: "application/pdf" });
        const url = URL.createObjectURL(blob);
        window.open(url, "_blank");

        if (chunkIndex < totalChunks - 1) {
          await new Promise((r) => setTimeout(r, 500));
        }
      }
      this.setState({ qrStage: "completed", qrProgress: undefined });
    } catch (e) {
      console.error("Download all QR PDFs failed", e);
      this.setState({
        qrStage: "completed",
        qrErrorMessage: "Failed to download QR PDFs.",
        qrProgress: undefined,
      });
    } finally {
      setTimeout(() => {
        if (!this.state.qrErrorMessage) {
          this.setState({
            loadingQr: false,
            qrStage: undefined,
            qrErrorMessage: undefined,
            qrProgress: undefined,
          });
        }
      }, 1200);
    }
  };

  private getLogoDataUrl = async (logo?: string): Promise<string> => {
    if (!logo) {
      return "";
    }
    if (logo.startsWith("data:")) {
      return logo;
    }
    let logoUrl = logo;
    if (logoUrl.startsWith("http://")) {
      try {
        const parsed = new URL(logoUrl);
        const isLocal = parsed.hostname === "localhost" || parsed.hostname === "127.0.0.1";
        if (!isLocal) {
          logoUrl = logoUrl.replace("http://", "https://");
        }
      } catch {
        logoUrl = logoUrl.replace("http://", "https://");
      }
    }
    try {
      const base64Logo = await this.getBase64FromUrl(logoUrl);
      return base64Logo;
    } catch (error) {
      console.warn(`Logo CORS error (will skip logo in PDF): ${logoUrl}`);
      return "";
    }
  };

  private getBase64FromUrl = async (url: string): Promise<string> => {
    try {
      // const proxyUrl = `${Config.API_SERVICE_URL}/logo-proxy?url=${encodeURIComponent(url)}`;
      const proxyUrl = url;
      const controller = new AbortController();
      const timeoutId = setTimeout(() => controller.abort(), 5000);
      const response = await fetch(proxyUrl, {
        signal: controller.signal,
      });

      clearTimeout(timeoutId);

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const blob = await response.blob();
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onloadend = () => resolve(reader.result as string);
        reader.onerror = reject;
        reader.readAsDataURL(blob);
      });
    } catch (err) {
      console.warn(`Failed to convert logo URL to base64: ${url}`, err);
      throw err;
    }
  };

  private getPositiveId = (value: unknown): number | undefined => {
    const parsed = Number(value);
    return Number.isInteger(parsed) && parsed > 0 ? parsed : undefined;
  };

  private fetchChainLogoDataUrl = async (): Promise<string> => {
    const { project } = this.props;
    let chainParentId;
    const chainId = this.getPositiveId((project as any)?.chain?.id);
    if (chainId) {
      try {
        const response = await axios.get(`${Config.API_SERVICE_URL}/api/chains/me`, getHeaders());
        const chains = Array.isArray(response.data) ? response.data : [];
        const matchedChain = chains.find((chain: any) => this.getPositiveId(chain?.id) === chainId);
        chainParentId =
          this.getPositiveId(matchedChain?.chain_parent_id) ??
          this.getPositiveId(matchedChain?.chain_parent);
      } catch {
        return "";
      }
    }

    if (!chainParentId) return "";
    return this.getLogoDataUrl(
      `${Config.API_SERVICE_URL}/api/chain-parent-logo/${chainParentId}/image`
    );
  };

  public handleGenerateQrPdf = async (
    file: File,
    storeName?: string,
    storeNumber?: string,
    fileLogo?: string
  ) => {
    try {
      this.setState({
        qrFileName: `${storeName || "Store"}-${file.file_name || file.name}`,
        qrFileUrl: file.blob_url,
        qrStoreName: storeName,
        qrStoreNumber: storeNumber,
      });
      const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms));
      const qrDataUrl = await QRCode.toDataURL(`${config.API_SERVICE_URL}/api/file/${file.id}`, {
        width: 300,
        margin: 1,
        errorCorrectionLevel: "H",
      });
      const base64Logo = await this.getLogoDataUrl(fileLogo);

      await new Promise<void>((resolve) => {
        this.setState(
          {
            loadingQr: true,
            qrStage: "generating",
            qrDataUrl,
            qrFileLogo: base64Logo,
          },
          async () => {
            const element = await this.waitForElement("qr-pdf");
            await this.waitForImages(element);
            requestAnimationFrame(() => setTimeout(resolve, 100));
          }
        );
      });
    } catch (e) {
      console.error(e);
      this.setState({ loadingQr: false, qrStage: undefined });
    }
  };
  private toUtcTimestamp = (date?: string | number): number => {
    if (!date) return 0;
    if (typeof date === "number") return date;
    const normalized = date.endsWith("Z") ? date : `${date}Z`;
    return new Date(normalized).getTime();
  };

  private getLatestFile = (files: File[]): File | null => {
    if (!files || files.length === 0) return null;

    return (
      files
        .filter((f) => f.extension === "pdf" && f.blob_url)
        .sort((a, b) => {
          const dateA = this.toUtcTimestamp(a.updated_at);
          const dateB = this.toUtcTimestamp(b.updated_at);
          return dateB - dateA; // latest first
        })[0] || null
    );
  };

  private createPdf = () => {
    return new jsPDF("portrait", "mm", "a4");
  };

  private addQrPageToPdf = async (pdf: jsPDF, isFirstPage: boolean) => {
    const element = document.getElementById("qr-pdf");
    if (!element) return;
    const images = element.getElementsByTagName("img");
    await Promise.all(
      Array.from(images).map(
        (img) => img.complete || new Promise((res) => (img.onload = img.onerror = res))
      )
    );
    try {
      const canvas = await html2canvas(element, {
        scale: 2,
        useCORS: true,
      });
      const imgData = canvas.toDataURL("image/png");
      if (!isFirstPage) {
        pdf.addPage();
      }
      pdf.addImage(imgData, "PNG", 0, 0, 210, 297);
    } catch (error) {
      console.error("PDF generation failed due to CORS/tainted canvas", error);

      this.setState({
        loadingQr: false,
        qrStage: undefined,
      });
    }
  };

  private generatePdfFromHtml = async () => {
    const element = document.getElementById("qr-pdf");
    if (!element) {
      console.warn("QR PDF element not found");
      return;
    }
    await this.waitForImages(element);
    const canvas = await html2canvas(element, {
      scale: 2,
      useCORS: true,
    });
    const imgData = canvas.toDataURL("image/png");
    const pdf = new jsPDF("portrait", "mm", "a4");
    pdf.addImage(imgData, "PNG", 0, 0, 210, 297);
    // pdf.save(`${this.state.qrFileName}-QR.pdf`);
    const blob = pdf.output("blob");
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  };

  // store files download with QR codes
  private handleStoreQrDownload = async (storeId: number) => {
    const { project, stores } = this.props;
    if (!project?.id) return;
    this.setState({ loadingQr: true, qrStage: "checking", qrErrorMessage: undefined });
    try {
      const response = await axios.get(
        `${Config.API_SERVICE_URL}/api/projects/${project.id}/stores/${storeId}/files`,
        getHeaders()
      );
      const storeFiles: File[] = Array.isArray(response.data) ? response.data : [];
      const downloadFiles = storeFiles.filter((f) => f.extension === "pdf" && f.blob_url);

      if (!downloadFiles.length) {
        this.setState({
          qrStage: "completed",
          qrErrorMessage: "No PDF files available for this store.",
        });
        return;
      }
      this.setState({ loadingQr: true, qrStage: "generating", qrFileName: "" });
      // Get store name for filename (find in stores prop)
      const store = stores?.find((s) => String(s.store_id) === String(storeId));
      const storeName = store?.store_name || "Store";
      const storeNumber = store?.store_number || store?.retail_store_num || "";

      this.setState({ qrStage: "generating" });
      const pdf = this.createPdf();
      let isFirstPage = true;

      // for (const file of downloadFiles) {
      //   const fileLogo = file.chain_parent_logo ? file.chain_parent_logo : DefaultChainLogo;
      //   await this.handleGenerateQrPdf(file, storeName, storeNumber, fileLogo);
      //   await new Promise((r) => setTimeout(r, 80));
      //   await this.addQrPageToPdf(pdf, isFirstPage);
      //   isFirstPage = false;
      // }

      const latestFile = this.getLatestFile(downloadFiles);

      if (!latestFile) {
        this.setState({
          qrStage: "completed",
          qrErrorMessage: "No PDF files available for this store.",
        });
        return;
      }

      this.setState({ loadingQr: true, qrStage: "generating" });

      const fileLogo = await this.fetchChainLogoDataUrl();
      await this.handleGenerateQrPdf(latestFile, storeName, storeNumber, fileLogo);
      await new Promise((r) => setTimeout(r, 80));
      await this.addQrPageToPdf(pdf, isFirstPage);
      isFirstPage = false;
      const blob = pdf.output("blob");
      const url = URL.createObjectURL(blob);
      window.open(url, "_blank");
      this.setState({
        qrStage: "completed",
        qrFileName: `${storeName} - All PDFs`, // batch message
      });
    } catch (e) {
      console.error("Store QR download failed", e);
      this.setState({
        qrStage: "completed",
        qrErrorMessage: "Failed to download QR codes for this store.",
      });
    } finally {
      setTimeout(() => {
        if (!this.state.qrErrorMessage) {
          this.setState({
            loadingQr: false,
            qrStage: undefined,
            qrDataUrl: "",
            qrFileUrl: "",
            qrFileName: "",
            qrErrorMessage: undefined,
          });
        }
      }, 1200);
    }
  };

  componentWillUnmount() {
    const { clearProject } = this.props;
    const { clearStore } = this.props;
    const { clearFiles } = this.props;
    const { clearAnnouncements } = this.props;
    clearProject();
    clearStore();
    clearFiles();
    clearAnnouncements();
  }

  downloadFeedbackAsCSV = async (id: string) => {
    const { fetchMyFeedback, fetchProjectComments, chainPermission } = this.props;

    const permission = chainPermission as Constants | undefined;
    const isProjectAdmin = permission === Constants.INTERNAL_PROJECT_ADMIN;

    try {
      let csvData: any[] = [];

      if (isProjectAdmin) {
        // Admin fetch ALL project comments
        const projectId = decryptProjectId(id);

        await fetchProjectComments(projectId);

        const commentsData = this.props.project_comments || [];

        if (!commentsData.length) {
          this.setState({ showNoCommentsModal: true });
          return;
        }

        // Transform feed back data
        csvData = commentsData.map((row: any) => ({
          commentID: row.commentId,
          projectName: row.projectName,
          storeNumber: row.storeNumber,
          storeName: row.storeName,
          action: row.actionId,
          reason: row.reasonId,
          productName: row.productName,
          productUPC: row.productUPC,
          swapProductName: row.productSubName,
          swapProductUPC: row.subUPC,
          comment: row.comment,
          user: `${row.firstName} ${row.lastName}`,
          email: row.email,
          employer: row.employer,
          createdDate: row.created_at,
          explanation: row.explanation,
          decision: row.feedback,
        }));
      } else {
        // Non-admin
        await fetchMyFeedback();

        const feedbackData = this.props.feedback;

        if (!feedbackData || feedbackData.length === 0) {
          this.setState({ showNoCommentsModal: true });
          return;
        }

        const filteredData = feedbackData.filter(
          (item) => String(item.project_id) === String(decryptProjectId(id))
        );

        if (filteredData.length === 0) {
          this.setState({ showNoCommentsModal: true });
          return;
        }

        csvData = filteredData;
      }

      // Create CSV only for matching items
      const csvContent = this.convertToCSV(csvData);

      const blob = new Blob([csvContent], { type: "text/csv;charset=utf-8;" });
      const link = document.createElement("a");
      const url = URL.createObjectURL(blob);

      link.setAttribute(
        "download",
        `comments_project_${id}_${new Date().toISOString().split("T")[0]}.csv`
      );

      link.href = url;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);

      URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Error downloading feedback:", error);
      alert("Failed to download feedback data");
    }
  };

  convertToCSV = (data: any[]): string => {
    if (!data || data.length === 0) return "";

    const allKeys = new Set<string>();
    data.forEach((item) => {
      Object.keys(item).forEach((key) => allKeys.add(key));
    });

    const headers = Array.from(allKeys);

    const headerRow = headers.map((header) => `"${header}"`).join(",");

    const dataRows = data.map((item) => {
      return headers
        .map((header) => {
          const value = item[header];
          if (value === null || value === undefined) return '""';
          if (typeof value === "object") return `"${JSON.stringify(value).replace(/"/g, '""')}"`;
          const stringValue = String(value);
          if (
            stringValue.includes(",") ||
            stringValue.includes('"') ||
            stringValue.includes("\n")
          ) {
            return `"${stringValue.replace(/"/g, '""')}"`;
          }
          return `"${stringValue}"`;
        })
        .join(",");
    });

    return [headerRow, ...dataRows].join("\n");
  };

  private handleZipDownload = async (
    filterExtensions: string[] | null // null = all files
  ) => {
    const { project, files } = this.props;
    if (!project?.id || !project?.chain?.id) return;

    const allFiles = files || [];

    const filtered = filterExtensions
      ? allFiles.filter((f) =>
          filterExtensions.some(
            (ext) => f.extension?.toLowerCase() === ext || f.name?.toLowerCase().endsWith(`.${ext}`)
          )
        )
      : allFiles;

    if (!filtered.length) return;
    const filePayload = filtered
      .filter((f) => f.storeno)
      .map((f) => ({ id: f.id, blob_url: f.blob_url, filename: f.name, status: f.status }));

    const url = `${Config.API_SERVICE_URL}/api/batch-download/files/zip`;
    const chunkSize = 250;
    const copiedFiles = [...filePayload];
    const chunks: typeof filePayload[] = [];

    // Mirror the chunking logic from the thunk
    if (copiedFiles.length === 0) {
      chunks.push([]);
    } else {
      while (copiedFiles.length > 0) {
        chunks.push(copiedFiles.splice(0, chunkSize));
      }
    }

    try {
      const responses = await Promise.all(
        chunks.map((chunk) =>
          axios.post(
            url,
            {
              chain: String(project?.chain?.name),
              project: String(project?.name),
              files: chunk,
              inclusive: true,
            },
            { ...getHeaders(), responseType: "blob" }
          )
        )
      );
      if (responses) {
        this.setState({ zipDownloadTriggered: true });
        setTimeout(() => {
          this.setState({ zipDownloadTriggered: false });
        }, 5000);
      }

      // Merge all chunk blobs into one zip download
      // const blob = new Blob(responses.map((r) => r.data), { type: "application/zip" });
      // const downloadUrl = URL.createObjectURL(blob);
      // const link = document.createElement("a");
      // link.href = downloadUrl;
      // link.download = `project-${project.id}-files.zip`;
      // document.body.appendChild(link);
      // link.click();
      // document.body.removeChild(link);
      // URL.revokeObjectURL(downloadUrl);
    } catch (e) {
      console.error("Zip download failed", e);
      this.setState({ zipDownloadTriggered: false });
    }
  };

  render() {
    const { id, roleId } = this.props.match.params;
    const { project, stores, files, projectError, announcements, authUser, history } = this.props;
    const { redirect, initialMountComplete, showNoCommentsModal } = this.state;
    const { chainPermission } = this.props;
    const projectId = decryptProjectId(id);
    if (redirect) {
      return <Redirect to="/my-feedback" />;
    }

    if (!project && projectError) {
      return <div>Project not found.</div>;
    }

    if (!project) {
      return <Loader />;
    }

    // if (project) {
    //   fetchLoggedUserChains(project?.chain?.id);
    // }
    const storedUser = getItem(IMPERSONATIONUSER);
    let impersonUser;
    if (storedUser) {
      impersonUser = JSON.parse(storedUser);
    }
    const parsedData: any = impersonUser || authUser;
    const userRole = parsedData?.role;
    const isValidation = String(project?.project_type || "").toLowerCase() === "validation";

    const columns = [
      {
        field: "store_number",
        header: "Store No",
        formatter: (_: any, row: any) => (
          <div>
            {row?.store_number ? (
              <Link
                to={`/projects-new/${projectId}/stores/${row.store_id}`}
                style={{ color: "#E5B611", textDecoration: "underline", cursor: "pointer" }}
              >
                {row.store_number}
              </Link>
            ) : (
              "-"
            )}
          </div>
        ),
      },
      { field: "store_name", header: "Store Name" },
      { field: "store_address", header: "Address" },
      { field: "store_status", header: "Status", formatter: (_ : any, row: any) => getCalculatedStatus(row, project?.timezone) },
      {
        id: "qr",
        field: "qr_code",
        header: "QR",
        sortable: false,
        formatter: (_: any, row: any) => (
          <QrCodeIcon
            style={{
              cursor: "pointer",
              color: "#363636ff",
              width: "20px",
              height: "20px",
            }}
            titleAccess="Download QR codes"
            onClick={(e: React.MouseEvent) => {
              e.stopPropagation();
              this.handleStoreQrDownload(row.store_id);
            }}
          />
        ),
      },
      {
        field: "store_validation_deadline",
        header: "Days Left",
        formatter: (row: any) => {
          const daysLeft = this.getDaysLeft(row);
          const isFuture = daysLeft >= 0;

          return (
            <div style={{ display: "flex", alignItems: "center", gap: "4px" }}>
              <span>
                {Math.abs(daysLeft)} {isFuture ? "" : ""}
              </span>
            </div>
          );
        },
      },
    ];
    if (isValidation) {
      const statusColumnIndex = columns.findIndex((col: any) => col.field === "store_status");
      const validatedColumn = {
        field: "user_completed",
        header: "Validated",
        formatter: (_: any, row: any) => (
          <span data-qa="user_completed">{Number(row?.user_completed) === 1 ? "Yes" : "No"}</span>
        ),
      };
      if (statusColumnIndex >= 0) {
        columns.splice(statusColumnIndex + 1, 0, validatedColumn);
      } else columns.push(validatedColumn);
    }

    return (
      <div>
        <div style={mainContainerStyle}>
          <div style={contentAreaStyle}>
            {/* Top Cards */}
            <div style={cardsContainerStyle}>
              <ProjectDetailsCard
                id={projectId}
                project={project}
                chainPermission={chainPermission}
                roleId={roleId}
              />
              <ProjectFilesCard
                files={files}
                id={Number(projectId)}
                history={this.props.history}
                roleId={roleId}
                project={project}
                userRole={userRole}
                isLoading={this.props.isLoadingFiles || !initialMountComplete}
              />
              <ProjectAnnouncementsCard
                announcements={announcements}
                chainPermission={chainPermission ? chainPermission : userRole}
              />
            </div>

            <Box style={tableHeaderStyle}>
              <Box>
                <Typography
                  variant="h6"
                  style={{ fontSize: "14px", fontWeight: 600, color: "#333" }}
                >
                  Stores
                </Typography>
                {this.state.zipDownloadTriggered && (
                  <Typography
                    variant="body2"
                    style={{ fontSize: "12px", color: "#000", marginTop: "2px" }}
                  >
                    {Constants.DOWNLOAD_FILES_SUCCESS_MESSAGE}
                  </Typography>
                )}
              </Box>
              <Box style={{ padding: isMobile ? "2px" : "20px" }}>
                <a
                  href="#"
                  style={tableLinkStyle}
                  onClick={(e) => {
                    e.preventDefault();
                    this.handleDownloadAllStoreQrPdfs();
                    // this.handleZipDownload(null);
                  }}
                >
                  Download All QR Codes <GetAppOutlined style={tableLinkIconStyle} />
                </a>

                {chainPermission !== Constants.CONTRIBUTER_NO_PSA_ACCESS &&
                  chainPermission !== Constants.VIEWER_NO_PSA_ACCESS &&
                  userRole !== Constants.CONTRIBUTER_NO_PSA_ACCESS &&
                  userRole !== Constants.VIEWER_NO_PSA_ACCESS && (
                    <a
                      href="#"
                      style={tableLinkStyle}
                      onClick={(e) => {
                        e.preventDefault();
                        // this.downloadPSAFiles();
                        this.handleZipDownload(["psa"]);
                        // this.props.history.push(`/manage-all-data/manage-psafiles/${id}`);
                      }}
                    >
                      All PSA Files <GetAppOutlined style={tableLinkIconStyle} />
                    </a>
                  )}
                <a
                  href="#"
                  style={tableLinkStyle}
                  onClick={(e) => {
                    e.preventDefault();
                    // this.downloadPDFFiles();
                    this.handleZipDownload(["pdf"]);
                    // this.props.history.push(`/manage-all-data/manage-psafiles/${id}`);
                  }}
                >
                  All PDF Files <GetAppOutlined style={tableLinkIconStyle} />
                </a>
                <a
                  href="#"
                  style={tableLinkStyle}
                  onClick={(e) => {
                    e.preventDefault();
                    // this.downloadAllFiles();
                    // this.props.history.push(`/manage-all-data/manage-files/${id}`);
                    this.props.history.push(
                      `/projects-new/${projectId}/${roleId}/downloads/${projectId}`
                    );
                  }}
                >
                  All Specific Files <GetAppOutlined style={tableLinkIconStyle} />
                </a>

                <a
                  href="#"
                  style={tableLinkStyle}
                  onClick={(e) => {
                    e.preventDefault();
                    this.downloadFeedbackAsCSV(id);
                  }}
                >
                  <span style={{ color: "#929497", marginRight: "12px" }}>| </span>
                  All Comments <GetAppOutlined style={tableLinkIconStyle} />
                </a>
                {(chainPermission === Constants.INTERNAL_PROJECT_ADMIN ||
                  chainPermission === Constants.EXTERNAL_PROJECT_ADMIN ||
                  chainPermission === Constants.CONTRIBUTER ||
                  chainPermission === Constants.CONTRIBUTER_NO_PSA_ACCESS ||
                  userRole === Constants.AB_SYSTEM_ADMIN ||
                  userRole === Constants.INTERNAL_PROJECT_ADMIN ||
                  userRole === Constants.EXTERNAL_PROJECT_ADMIN) && (
                  <a
                    href=""
                    style={{
                      color: "#3E81F4",
                      fontSize: "12px",
                      textDecoration: "none",
                      marginRight: "16px",
                      fontWeight: 600,
                    }}
                    onClick={() => this.handleClickOnFeedBack(String(projectId), roleId)}
                  >
                    <span style={{ color: "#929497", marginRight: "12px" }}>| </span>
                    <img
                      src={myFeedback}
                      alt="Attachment Icon"
                      width="16"
                      height="16"
                      style={{ marginRight: "6px" }}
                      onClick={() => this.handleClickOnFeedBack(String(projectId), roleId)}
                    />
                    My Feedback
                  </a>
                )}
              </Box>
            </Box>
            {project && (
              <LightThemeTable
              data={stores}
              columns={columns}
              onClickOnRow={this.handleClickOnRow}
              isLoading={this.props.isLoadingStores || !initialMountComplete}
              />
            )}
          </div>
        </div>

        {/* No Comments Modal */}
        <Dialog
          open={showNoCommentsModal}
          onClose={this.handleCloseModal}
          aria-labelledby="no-comments-dialog-title"
        >
          {/* <DialogTitle
          id="no-comments-dialog-title"
          style={{ fontSize: "12px" }}
        >
          No Comments Available
        </DialogTitle> */}

          <DialogContent>
            <Typography style={{ fontSize: "12px" }}>No comments available to download.</Typography>
          </DialogContent>

          <DialogActions>
            <Button
              onClick={this.handleCloseModal}
              variant="contained"
              style={{
                backgroundColor: "#E5B611",
                color: "#000", // optional: better contrast
                fontSize: "12px",
              }}
            >
              OK
            </Button>
          </DialogActions>
        </Dialog>
        {this.state.loadingQr && (
          <QrOverlay
            qrStage={this.state.qrStage}
            fileName={this.state.qrFileName}
            checkingText="Checking for PDF files..."
            // generatingText="Generating the QR codes for the files..."
            generatingText={(() => {
              const p = this.state.qrProgress;
              if (!p) return "Generating the QR codes for the files...";
              const totalPdfs = Math.ceil(p.total / 1000);
              const currentPdf = Math.min(Math.ceil((p.current + 1) / 1000), totalPdfs);
              const label = totalPdfs > 1 ? `(PDF ${currentPdf}/${totalPdfs}) ` : "";
              return `Generating QR codes... ${label}${p.current}/${p.total} done`;
            })()}
            successText={this.state.qrErrorMessage || "Successfully downloaded the Store files."}
            // onClose={this.state.qrErrorMessage ? this.handleCloseQrOverlay : undefined}
            onClose={this.handleCloseQrOverlay}
          />
        )}
        {this.state.qrDataUrl && (
          <QrPdfTemplate
            store={{
              chain_name: project?.chain?.name || "Project",
              chain_logo: project?.chain?.logo
                ? `data:image/png;base64,${project.chain.logo}`
                : DefaultChainLogo,
              store_name: this.state.qrStoreName,
              store_number: this.state.qrStoreNumber,
            }}
            fileLogo={this.state.qrFileLogo}
            qrDataUrl={this.state.qrDataUrl}
            qrFileUrl={this.state.qrFileUrl}
            containerId="qr-pdf"
          />
        )}
      </div>
    );
  }
}

const connector = connect(
  (state: State) => ({
    user: state.auth_user.content,
    authUser: state.auth_user.content,
    project: state.project.content,
    projectError: state.project.error,
    stores: state.stores.content?.data,
    isLoadingStores: state.stores.loading,
    files: state.files.content?.data,
    isLoadingFiles: state.files.loading,
    announcements: state.announcements.content,
    chainRole: state.logged_user_chains_permission.chainRole,
    chainPermission: state.logged_user_chains_permission.chainPermission,
    feedback: state.my_feedback.content,
    fetchZipForFilesDownload,
    project_comments: state.project_comments.content,
  }),
  {
    fetchProject,
    fetchStoresByProjectId,
    fetchFilesByProjectId,
    createAnalyticsEvent,
    trackPageView,
    fetchMyProjectAnnouncements,
    fetchLoggedUserChainsRole,
    clearProject,
    clearStore,
    clearFiles,
    clearAnnouncements,
    fetchMyFeedback,
    fetchAllFiles,
    fetchProjectComments,
  }
);

type PropsFromRedux = ConnectedProps<typeof connector>;

export default withRouter(connector(Project));
